module.exports = __webpack_public_path__ + "img/christmascoupon_en.848f2beb.png";